const lyrics = [
  "E a gente se escolhe todo dia",
  "E eu te escolheria mais milhões de vidas",
  "Porque uma só é pouco com você, amor",
  "Eu quero tudo o que eu puder viver, amor",
];

function OurSong() {
  return (
    <div
      id="our-song"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <blockquote className="our-song-quote">
          {lyrics.map((line, i) => (
            <h1 key={i} className="mb-4">
              {line}
            </h1>
          ))}
        </blockquote>
        <br />
        <iframe
          title="Nossa música no Spotify"
          data-testid="embed-iframe"
          className="our-song-player"
          style={{ borderRadius: "12px" }}
          src="https://open.spotify.com/embed/track/4PxTFojApbNeeIwiEEx2QX?utm_source=generator&theme=0&si=08187df2c58a455e"
          height="152"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default OurSong;
